import { call, put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { SETS_PAGE_LIMIT } from '../../components/setsInventory/setsInventoryConstants';
import {
    GET_INVENTORY_LIST_SUCCESS,
    GET_INVENTORY_LIST_FAILURE,
} from '../actions';

export default function* getInventoryListSaga(action) {
    const baseSiteId = localStorage.getItem('baseSiteId') || 'defaultSite';
    const params = {
        currentPage: 0,
        pageSize: SETS_PAGE_LIMIT,
        ...action.payload,
    };
    const queryString = Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null && v !== '')
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
    const url = `/occ/v2/${baseSiteId}/inventory/sets${queryString ? `?${queryString}` : ''}`;

    try {
        const { data } = yield call(axios.get, url);
        yield put({
            type: GET_INVENTORY_LIST_SUCCESS,
            payload: data,
        });
    } catch (error) {
        logUiErrorToBackend(error, { apiEndPoint: url });
        yield put({
            type: GET_INVENTORY_LIST_FAILURE,
            payload: errorHandler(error?.response?.status || '503'),
        });
    }
}
